var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"mondays-view-frame",attrs:{"src":"https://view.monday.com/embed/1897718256-d8731578d55e355106e8c703763c3845?r=use1"}})}
var staticRenderFns = []

export { render, staticRenderFns }